import { apiAuth, apiResponseType } from ".";

export const getDistributionProcessesGrouped = (
  page: number = 1,
  filters?: {
    contest_id?: number;
    unity_id?: number;
    seller_id?: number;
  }
): apiResponseType => {
  let url = `distribution-processes/grouped?page=${page}`;

  if (filters?.contest_id) {
    url += `&contest_id=${filters.contest_id}`;
  }
  if (filters?.unity_id) {
    url += `&unity_id=${filters.unity_id}`;
  }
  if (filters?.seller_id) {
    url += `&seller_id=${filters.seller_id}`;
  }

  return apiAuth.get(url) as apiResponseType;
};

export const getDistributionProcessProductDetails = (
  contestId: number,
  page: number = 1
): apiResponseType => {
  return apiAuth.get(
    `distribution-processes/product-details?contest_id=${contestId}&page=${page}`
  ) as apiResponseType;
};
